import axiosInstance from "../../../setupAxios";
import { IWorkflow } from "../../types/IWorkflow";
import { IUsage } from "../../types/usageTypes/IUsage";
import { IUsageGroupLocation } from "../../types/usageTypes/IUsageGroupLocation";
import { IUsageGroupSetListAdditional } from "../../types/usageTypes/IUsageGroupSetListAdditional";
import { IUsageMatch } from "../../types/usageTypes/IUsageMatch";
import { IUsageGroupVenueDetails } from "../../types/usageTypes/IUsageGroupVenueDetails";
import { IUsageGroup } from "../../types/usageTypes/IUsageGroup";
import { IDistributionState } from "../../../redux/types/IDistributionState";
import { IUsagePoolState } from "../../../redux/types/IUsagePoolState";
import { ILicenseUsage } from "../../types/usageTypes/ILicenseUsage";
import { IArtist } from "../../types/IArtist";
import { ICustomerVenue } from "../../types/ISetListVenue";

export class UsageService {
    
    public static getUsage(usageID: string): Promise<IUsageGroup> {
        return new Promise<IUsageGroup>((resolve, reject) => {
            axiosInstance
                .get("/usage/id/" + usageID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err.response.status);
                });
        });
    }

    public static getDistributions(): Promise<IDistributionState[]> {
        return new Promise<IDistributionState[]>((resolve, reject) => {
            axiosInstance.get("Distribution/Distributions/")
                .then(res => {
                    resolve(res.data);
                })
        });
    }

    public static getPools(): Promise<IUsagePoolState[]> {
        return new Promise<IUsagePoolState[]>((resolve, reject) => {
            axiosInstance.get("usagePool/Pools/")
                .then(res => {
                    resolve(res.data);
                })
        });
    }
    public static getSources(matchType: string, level: number): Promise<string[]> {
        return new Promise<string[]>((resolve, reject) => {
            axiosInstance.get("Sources/GetSourcesByMatchType/" + matchType + "/" + level)
                .then(res => {
                    resolve(res.data);
                })
        });
    }

    static saveUsageGroup(
        matchingWorks: IUsageMatch[], 
        workflows: IWorkflow[], 
        id: string, 
        matchStatus: string,
        poolCode: string,
        usages?: IUsage[],
        location?: IUsageGroupLocation,
        setListAdditional?: IUsageGroupSetListAdditional,
        approvalStatus?: string,
        venueDetails?: IUsageGroupVenueDetails,
        isFromSearchResults?: boolean,
        qaStatus?: string,
        comments?: any,
        licenses?: ILicenseUsage[],
        setListArtist?: IArtist[],
        customerVenues?: ICustomerVenue[],
        catOne?: string,
        catTwo?: string,
        createMatchHistory?: boolean,
        usagePool?: IUsagePoolState
    ): Promise<any> {
        const url: string = "usage/save/" + id;
        let usageRowData: IUsage[] = [];
        if(usages === undefined || usages === null) {
            usages = usageRowData;
        }
        var data = {
            usageMatches: matchingWorks,
            workflows: workflows,
            matchStatus: matchStatus,
            usages: usages,
            location: { ... location },
            setListAdditional: {...setListAdditional },
            approvalStatus,
            venueDetails: { ...venueDetails },
            isFromSearchResults: isFromSearchResults,
            qaStatus: qaStatus || null,
            comments: comments || null,
            licenses: licenses || null,
            setListArtist: setListArtist || null,
            customerVenues: customerVenues || null,
            catOne: catOne || null,
            catTwo: catTwo || null,
            createMatchHistory: createMatchHistory,
            poolCode: poolCode || null,
            usagePool: usagePool ? { ...usagePool } : null
        };
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .post(url, data)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    static async mergeUsage(usageGroup: IUsageGroup, targetUsageGroupID: number, mergeOption: string): Promise<any> {
        const url: string = "usage/merge/" + targetUsageGroupID + '/' + mergeOption;
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .patch(url, usageGroup)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    static async updateUsageApprovalStatus(
        usageGroupId: string,
        approved: boolean
    ): Promise<any> {
        
        const data = {
            approved: approved
        }

        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .put(`usage/approval/${usageGroupId}`, data)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    static undoUsageIngestion(fullFilePath: string): Promise<any> {
        const url: string = encodeURI("storage/undo/" + fullFilePath);
        return new Promise<any>((resolve, reject) => {
            axiosInstance.delete(url).then(res => resolve(res)).catch(err => reject(err));
        });
    }

    public static getPaymentRunIDs(): Promise<string[]> {
        return new Promise<string[]>((resolve, reject) => {
            axiosInstance.get("usage/getPaymentRunIDs")
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }
    static saveRegroupedUsage(regroupedUsage: IUsageGroup,id?:string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .post(`usage/saveRegroupedUsageGroup/${id}`, regroupedUsage)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                })
        })
    }
}

